<app-loader [Parent]="this"></app-loader>

@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
      <form-edit-button>Edit</form-edit-button>
      <app-form-delete-button [Model]="Model" [Parent]="this" DeleteUrl="integrations/orikan/configuration/"
        [DeleteCheck]="false"
        DeleteNavLink="/integrations/orikan">
      </app-form-delete-button>
    </app-pageheader>
    <div class="columns is-justify-content-center">
      <div class="column is-7">
        <article class="panel">
          <p class="panel-heading">
            {{Model.Name || 'Orikan Configuration'}}
          </p>
          <a class="panel-block">
            <span class="label">Base URL</span>
            <span class="value">{{Model.BaseUrl}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Username</span>
            <span class="value">{{Model.Username}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Description</span>
            <span class="value">{{Model.Description}}</span>
          </a>
        </article>
      </div>
    </div>
  </div>
}